import AdminApi from '../../services/api'
import Loc from "../../services/localization";
import swal from "sweetalert2";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            filterType: "day",
            isLoading: false,
            isLoadingSave: false,
            notesToEdit: null,
            selectedDate: new Date().toISOString().split('T')[0],
            selectedWeek: this.getCurrentWeek(),
            selectedMonth: new Date().toISOString().slice(0, 7),
            fromDate: new Date(),
            toDate: new Date(),
            notes: [],
            output: "",
            newNotes: "",
            filters: [
                {
                    id: "day",
                    name: LocService.t('label_filter_day')
                },
                {
                    id: "week",
                    name: LocService.t('label_filter_week')
                },
                {
                    id: "month",
                    name: LocService.t('label_filter_month')
                }
            ]
        };
    },
    methods: {
        clickSelect: clickSelect,
        getChipClass: getChipClass,
        isSelected: isSelected,
        loadData: loadData,
        saveNewNotes: saveNewNotes,
        updateNotes: updateNotes,
        editItem: editItem,
        deleteItem: deleteItem,
        getDayFromDate: getDayFromDate,
        getCurrentWeek() {
            let date = new Date();
            let year = date.getFullYear();
            let week = this.getWeekNumber(date);
            return `${year}-W${week.toString().padStart(2, '0')}`;
        },
        getWeekNumber(date) {
            let firstDay = new Date(date.getFullYear(), 0, 1);
            let days = Math.floor((date - firstDay) / (24 * 60 * 60 * 1000));
            return Math.ceil((days + firstDay.getDay() + 1) / 7);
        },
        getDateRange() {
            let startDate, endDate;

            if (this.filterType === "day") {
                startDate = this.selectedDate;
                endDate = startDate;
                this.fromDate = startDate;
                this.toDate = endDate;
            } else if (this.filterType === "week") {
                let [year, week] = this.selectedWeek.split('-W').map(Number);
                let firstDayOfWeek = new Date(year, 0, (week - 1) * 7 + 1);
                while (firstDayOfWeek.getDay() !== 1) {
                    firstDayOfWeek.setDate(firstDayOfWeek.getDate() - 1);
                }
                let lastDayOfWeek = new Date(firstDayOfWeek);
                lastDayOfWeek.setDate(lastDayOfWeek.getDate() + 7);
                let firstDayInWeek = new Date(firstDayOfWeek);
                firstDayInWeek.setDate(firstDayInWeek.getDate() +1)
                startDate = firstDayInWeek.toISOString().split('T')[0];
                endDate = lastDayOfWeek.toISOString().split('T')[0];
                this.fromDate = firstDayInWeek;
                this.toDate = lastDayOfWeek;
            } else if (this.filterType === "month") {
                let [year, month] = this.selectedMonth.split('-').map(Number);
                let startOfMonth = new Date(year, month - 1, 1);
                startOfMonth.setDate(startOfMonth.getDate() + 1)
                let endOfMonth = new Date(year, month, 0)
                endOfMonth.setDate(endOfMonth.getDate() + 1)
                this.fromDate = startOfMonth;
                this.toDate = endOfMonth;
                startDate = startOfMonth.toISOString().split('T')[0];
                endDate = endOfMonth.toISOString().split('T')[0];
            }

            if(this.filterType === "day"){
                this.output = `${startDate}`;
            }else{
                this.output = `${startDate} - ${endDate}`;
            }
            this.loadData();
        },
        updateInputs() {
            if (this.filterType === "day") {
                this.selectedDate = new Date().toISOString().split('T')[0];
            } else if (this.filterType === "week") {
                this.selectedWeek = this.getCurrentWeek();
            } else if (this.filterType === "month") {
                this.selectedMonth = new Date().toISOString().slice(0, 7);
            }
            this.changeDate(0)
        },
        changeDate(step) {
            this.notesToEdit = null;
            this.newNotes = "";
            if (this.filterType === "day") {
                let date = new Date(this.selectedDate);
                date.setDate(date.getDate() + step);
                this.selectedDate = date.toISOString().split('T')[0];

            } else if (this.filterType === "week") {
                let [year, week] = this.selectedWeek.split('-W').map(Number);

                // Pronađi prvi dan nedelje (ponedeljak)
                let firstDayOfWeek = new Date(year, 0, 1);
                firstDayOfWeek.setDate(firstDayOfWeek.getDate() + (1 - firstDayOfWeek.getDay()) + (week - 1) * 7);

                // Pomeri nedelju za step u danima (7 dana za svaku nedelju)
                firstDayOfWeek.setDate(firstDayOfWeek.getDate() + step * 7);

                // Vratiti nedelju u format YYYY-WXX
                let newYear = firstDayOfWeek.getFullYear();
                let newWeek = this.getWeekNumber(firstDayOfWeek);
                this.selectedWeek = `${newYear}-W${newWeek.toString().padStart(2, '0')}`;

            } else if (this.filterType === "month") {
                let [year, month] = this.selectedMonth.split('-').map(Number);
                month += step;
                if (month < 1) {
                    month = 12;
                    year -= 1;
                } else if (month > 12) {
                    month = 1;
                    year += 1;
                }
                this.selectedMonth = `${year}-${month.toString().padStart(2, '0')}`;
            }
            this.getDateRange();
        }
    },

    beforeMount() {
        this.getDateRange();
        this.loadData();
    }
}

function loadData(){
    let _self = this;
    _self.isLoading = true;
    let request = {
        fromDate: _self.$moment(_self.fromDate).format('DD-MM-YYYY'),
        toDate: _self.$moment(_self.toDate).format('DD-MM-YYYY')
    }

    AdminApiService.getUserNotes(request)
        .then((response) => {
            _self.notes = response.data;
            _self.isLoading = false;
        })
        .catch((error) => {
            _self.isLoading = false;
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function saveNewNotes(){
    let _self = this;
    if(_self.notesToEdit != null){
        _self.updateNotes();
        return;
    }
    _self.isLoadingSave = true;
    let request = {
        date: _self.$moment(_self.fromDate).format('DD-MM-YYYY'),
        notes: _self.newNotes
    }

    AdminApiService.addUserNotes(request)
        .then((response) => {
            _self.newNotes = "";
            _self.loadData();
            _self.isLoadingSave = false;
        })
        .catch((error) => {
            _self.isLoadingSave = false;
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function updateNotes(){
    let _self = this;
    _self.isLoadingSave = true;
    let request = {
        date: _self.notesToEdit.date,
        notes: _self.newNotes
    }

    AdminApiService.updateUserNotes(request, _self.notesToEdit.id)
        .then((response) => {
            _self.newNotes = "";
            _self.notesToEdit = null;
            _self.loadData();
            _self.isLoadingSave = false;
        })
        .catch((error) => {
            _self.isLoadingSave = false;
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function getChipClass(item) {
    if (this.filterType === item.id) {
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelected(item) {
    return this.filterType === item.id
}

function clickSelect(item) {
    if(this.filterType !== item.id){
        this.filterType = item.id;
        this.getDateRange();
    }
}


function editItem(item){
    this.notesToEdit = item;
    this.newNotes = item.notes;
 }

function deleteItem(item){
    let _self = this;
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_user_note_delete_desc'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        _self.isLoading = true;
        AdminApiService.deleteUserNotes(item.id)
            .then((response) => {
                _self.loadData();
            })
            .catch(error => {
                _self.isLoading = false;
                swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });
}

function getDayFromDate(dateString){
    const [day, month, year] = dateString.split("-");
    const date = new Date(year, month - 1, day);

// Dobij dan u sedmici (0 je nedelja, 1 je ponedeljak, itd.)
    const dayOfWeek = date.getDay();

    switch (dayOfWeek) {
        case 1:
            return LocService.t('day_monday')
        case 2:
            return LocService.t('day_tuesday')
        case 3:
            return LocService.t('day_wednesday')
        case 4:
            return LocService.t('day_thursday')
        case 5:
            return LocService.t('day_friday')
        case 6:
            return LocService.t('day_saturday')
        case 0:
            return LocService.t('day_sunday')
    }
}



// WEBPACK FOOTER //
// ./src/components/TrainingNotes/TrainingNotes.js